import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown} from '@fortawesome/free-solid-svg-icons';
import SmallHeading from './../components/SmallHeading';
import Heading from './../components/Heading';
import DetailsHeading from './../components/DetailsHeading';
import { Link } from 'react-router-dom';

const gfaqs = [
    { id: 1, question: "What is PocketLPO?", answer: "PocketLPO is a legal process outsourcing provider offering remote in-house counsel services. We specialize in delivering cost-effective, scalable, and expert legal support tailored to businesses of all sizes." },
    { 
        id: 2, 
        question: "What services do you offer?", 
        answer: `We offer a wide range of non-litigation legal services, including:
        • Corporate Governance & Compliance
        • Contract Management & Review
        • Intellectual Property Management
        • HR Legal Support
        • Data Privacy & Protection
        • M&A and Corporate Transaction Support

        Note: For a detailed list, please visit our Services Page.`
      },      
    { id: 3, question: "How is PocketLPO different from a traditional law firm?", answer: "PocketLPO operates as a strategic legal partner rather than a traditional law firm. We do not engage in litigation or provide legal representation. Instead, we specialize in supporting businesses with preventive law strategies, legal process management, and transactional assistance. Our model is designed to offer remote, flexible, and cost-effective solutions to meet your operational needs." },
];
const gsfaqs = [
    { id: 4, question: "How do I sign up for your services?", 
        answer: `You can get started by:
        1.	Choosing a plan on our Pricing Page.
        2.	Contacting us through our Contact Form.
        3.	Scheduling a free consultation to discuss your needs.
    `},      
    { id: 5, question: "What is the onboarding process? ", 
        answer: `Once you sign up, we:
        1.	Assign a dedicated legal expert to your account.
        2.	Conduct an initial meeting to understand your requirements.
        3.	Begin delivering services according to the agreed plan.
    `},
];


const MainFAQ = () => {
    const [openId, setOpenId] = useState(null);

    const toggleFAQ = (id) => {
        setOpenId(prevId => (prevId === id ? null : id));
    };

    return (
        <section className="py-10">
            <SmallHeading name="FAQs" tstyle="text-center my-1 pt-10"/>
            <Heading name="Frequently Asked Questions" tstyle="text-center my-1"/>
            <div className='mt-4 px-10' >
                <DetailsHeading 
                 name="Welcome to the PocketLPO FAQ page! Here, we answer common questions about our services, pricing, and how we can support your business's legal needs." 
                 tstyle="my-1"
                />
            </div>
            <div className="grid grid-cols-1 items-center">
                <div className='mx-10 md:mx-20'>
                    <div className="grid grid-cols-1 gap-4 mt-10 ">
                    <SmallHeading name="General Questions" tstyle="text-center font-bold"/>
                        {gfaqs.map((faq) => (
                            <div key={faq.id} className="border rounded-lg overflow-hidden shadow-md">
                                <button
                                    className={`flex justify-between items-center w-full p-4
                                    ${openId === faq.id ? ' text-white bg-emerald-600 opacity-80' : 'bg-emerald-50'}`}

                                    onClick={() => toggleFAQ(faq.id)}
                                >
                                    <span className="text-lg font-medium">{faq.question}</span>
                                    <FontAwesomeIcon 
                                        className={`w-5 h-5 text-xl transition-transform duration-300
                                            ${openId === faq.id ? '-rotate-180' : 'rotate-0'}`} 
                                        icon={faChevronDown} 
                                    />
                                </button>
                                {openId === faq.id && (
                                    <div className="whitespace-pre-line p-4 bg-white border-t">
                                        {faq.answer}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>

                  
                    <div className="grid grid-cols-1 gap-4 mt-4">
                    <SmallHeading name="Getting Started" tstyle="text-center font-bold"/>
                        {gsfaqs.map((faq) => (
                            <div key={faq.id} className="border rounded-lg overflow-hidden shadow-md">
                                <button
                                    className={`flex justify-between items-center w-full p-4
                                    ${openId === faq.id ? ' text-white bg-emerald-600 opacity-80' : 'bg-emerald-50'}`}

                                    onClick={() => toggleFAQ(faq.id)}
                                >
                                    <span className="text-lg font-medium">{faq.question}</span>
                                    <FontAwesomeIcon 
                                        className={`w-5 h-5 text-xl transition-transform duration-300
                                            ${openId === faq.id ? '-rotate-180' : 'rotate-0'}`} 
                                        icon={faChevronDown} 
                                    />
                                </button>
                                {openId === faq.id && (
                                    <div className="whitespace-pre-line p-4 bg-white border-t">
                                        {faq.answer}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className="flex mt-10 justify-center">
                <Link 
                    to="faq"
                    onClick={() => window.scrollTo(0, 0)}
                    className="bg-emerald-600 text-white px-6 py-3 rounded-xl hover:translate-y-1">
                    Read More
                </Link>
            </div>              
        </section>        
    );
};

export default MainFAQ;
